var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-observer',{scopedSlots:_vm._u([{key:"default",fn:function({ valid }){return [_vm._t("default"),_c('validation-watcher',{attrs:{"valid":valid,"step-index":_vm.stepIndex}})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }